import { AvailabilityResponseResponseBuilder } from 'gql/autogen/AvailabilityResponseResponseBuilder';
import { AvailabilityActivityResultResponseBuilder } from 'gql/autogen/AvailabilityActivityResultResponseBuilder';
import { ActivityResponseBuilder } from 'gql/autogen/ActivityResponseBuilder';
import { OfferPricingResponseBuilder } from 'gql/autogen/OfferPricingResponseBuilder';
import { OfferResponseBuilder } from 'gql/autogen/OfferResponseBuilder';
import { PaymentResponseBuilder } from 'gql/autogen/PaymentResponseBuilder';
import { CancellationResponseBuilder } from 'gql/autogen/CancellationResponseBuilder';
import { CancellationPolicyResponseBuilder } from 'gql/autogen/CancellationPolicyResponseBuilder';
import { PricingSummaryResponseBuilder } from 'gql/autogen/PricingSummaryResponseBuilder';
import { PricingResponseBuilder } from 'gql/autogen/PricingResponseBuilder';
import { buildPricingDisplayResponseBuilder } from 'gql/activityBuilder/pricingDisplayResponseQueryBuilder';
import { buildSearchErrorResponse } from 'gql/activityBuilder/commonQueryBuilders';
import { EnrichedOfferOptionResponseBuilder } from 'gql/autogen/EnrichedOfferOptionResponseBuilder';
import { SpecificationResponseBuilder } from 'gql/autogen/SpecificationResponseBuilder';
import { BookingRequirementResponseBuilder } from 'gql/autogen/BookingRequirementResponseBuilder';
import { PaxRequirementResponseBuilder } from 'gql/autogen/PaxRequirementResponseBuilder';

const build = (): AvailabilityResponseResponseBuilder => {
    // GQL Server throws error when we use fragments at the moment, needs detailed analysis
    // const priceResponse = new PriceResponseBuilder().withInc().withExc();
    // const chargeAmount = new ChargeAmountResponseBuilder().withChargeTotal();
    // const summaryElementResponse = new SummaryElementResponseBuilder().withTotal(new DisplayTotalPriceResponseBuilder().withExclusive(chargeAmount).withAllInclusive(chargeAmount));

    return new AvailabilityResponseResponseBuilder()
        .withIsSuccess()
        .withResult(
            new AvailabilityActivityResultResponseBuilder().withIsCompleted().withActivity(
                new ActivityResponseBuilder()
                    .withIsAvailable()
                    .withMasterActivityId()
                    .withMasterSupplierId()
                    .withOfferPricing(
                        new OfferPricingResponseBuilder()
                            .withTravelDate()
                            .withOffers(
                                new OfferResponseBuilder()
                                    .withIsCartEligible()
                                    .withOfferId()
                                    .withOfferGroupId()
                                    .withOfferGroupDetailRef()
                                    .withOfferDetailRef()
                                    .withActivityId()
                                    .withSupplierActivityCode()
                                    .withSupplierOfferCode()
                                    .withIsAvailable()
                                    .withPayment(
                                        new PaymentResponseBuilder()
                                            .withPaymentModel()
                                            .withCancellation(
                                                new CancellationResponseBuilder()
                                                    .withCancellationType()
                                                    .withPolicies(new CancellationPolicyResponseBuilder().withPenaltyCode().withHoursFrom().withHoursUntil()),
                                            ),
                                    )
                                    .withEnrichedOfferOption(
                                        new EnrichedOfferOptionResponseBuilder()
                                            .withOfferId()
                                            .withOfferOptionId()
                                            .withSupplierOfferOptionCode()
                                            .withSpecification(new SpecificationResponseBuilder().withKey().withSpecification())
                                            .withBookingRequirementRefId()
                                            .withIsAvailable()
                                            .withOfferOptionToken()
                                            .withAvailableQuantity()
                                            .withOfferDetailsReference()
                                            .withPricingSummary(
                                                new PricingSummaryResponseBuilder().withPricing(
                                                    new PricingResponseBuilder().withCurrency().withDisplay(buildPricingDisplayResponseBuilder()),
                                                ),
                                            )
                                            .withBookingRequirementRefId(),
                                    ),
                            )
                            .withBookingRequirements(new BookingRequirementResponseBuilder().withId().withAdultRequired().withMinPax().withMaxPax().withPaxRequirementRefId())
                            .withPaxRequirements(
                                new PaxRequirementResponseBuilder()
                                    .withId()
                                    .withCode()
                                    .withMinAge()
                                    .withMaxAge()
                                    .withMinPax()
                                    .withMaxPax()
                                    .withMinPaxWhenSelected()
                                    .withPaxIncrementalStep(),
                            ),
                    ),
            ),
        )
        .withErrors(buildSearchErrorResponse());
};

export default build;
